<template>
  <div class="assign-solo">
    <div v-for="(item, index) in showData" :key="item.driverId" @click="checkoutDriver(item, index)" >
      <div class="item" :class="{
        selected: item.driverId === currentId,
      }"
      >
        <div class="box"/>
        <div class="driver">
          <div class="left">
            <fl-avatar :size="20" class="avatar" :fleet-id="item.driverId" :nickname="`${item.firstName || ''} ${item.lastName}`" :src="item.userImage"></fl-avatar>
<div class="role">
            <div class="name">
              <common-ellipsis-tooltip
                effect="dark"
                :content="(item.firstName || '') + ' ' + (item.lastName || '')"
                placement="top"
                :index="index"
              ></common-ellipsis-tooltip>
            </div>
            <span class="text">
              {{item.role===0?'Admin':item.role===2?'Operator':item.role===1?'Driver':''}}
            </span>
</div>
          </div>
          <div class="right">{{ item.eldLastUpdateTime ? timeDiffAll(item.eldLastUpdateTime).timeDiffData : '--'}}</div>
        </div>
        <div class="desc line-bottom">
          <div class="left">Last update location</div>
          <div class="right">
            <common-ellipsis-tooltip
              effect="dark"
              :content="item.currentLocation || ''"
              placement="top"
            >
              <span class="text">{{ item.currentLocation || "" }}</span>
            </common-ellipsis-tooltip>
          </div>
        </div>
        <div class="desc line1">
          <div class="left">Empty Mile</div>
          <div class="right">
            <calcUpdateMilesVue 
              @input="input"
              :index="index"
              :isLoading="item.calcLoading ? true : false"
              :text="item.emptyMils ? String(item.emptyMils) : ''"
              :isEditActive="item.eidtCalc == 'EDIT'"
              :isEditable="item.eidtCalc == 'EDIT' && currentId == item.driverId"
            />
          </div>
        </div>
        <div class="eld-info-container" v-if="item.driverConnectedEld">
             <div class="eld-item">
                <p>Break</p>
                <p>{{(item.breakTime ) || '--'}}</p>
            </div>
            <div class="eld-item">
                <p>Drive</p>
                <p>{{(item.driveTime ) || '--'}}</p>
            </div>
            <div class="eld-item">
                <p>Shift</p>
                <p>{{(item.shiftTime) || '--'}}</p>
            </div>
            <div class="eld-item">
                <p>Cycle</p>
                <p>{{(item.cycleTime ) || '--'}}</p>
            </div>
        </div>
        <div class="no-eld-info-container" v-else>
            <svg-icon
                name="eld-disconnect"
                :style="{
                width: '16px',
                height: '16px',
                }"
            />
            <span>ELD Disconnect, HOS info unavailable</span>
        </div>
        <div class="split" v-if="showData.length - 1 !== index"></div>
      </div>
    </div>
  </div>
</template>

<script>
import tools from "@/tools/format-date"
import { mapState } from 'vuex'
import calcUpdateMilesVue from './calc-update-miles.vue'
export default {
  name: "assign-solo",
  components: { calcUpdateMilesVue },
  props: {
    filterData: Array,
    driverSelected: Function,
    keyWord: String,
    optionsRole: Array,
    currentMilesType: Number
  },
  computed: {
      ...mapState({
          connectEld: (state) => state.user.connectEld,
      }),
  },
  data() {
    return {
      currentId: '',
      showData: [],
      cacheFilterData: []
    }
  },
  created() {
    this.updateList()
  },
  watch: {
    keyWord() {
      this.updateList()
    },
    optionsRole(){
      this.updateList()
    },
    filterData() {
      this.updateList()
    }
  },
  methods: {
    checkoutDriver(item, index) {
      this.currentId = item.driverId;
      this.driverSelected(item)
      this.calcClick(item, index)
    },
    updateList() {
      this.showData = this.filterData;
    },
    calcClick(item, index) {
      console.log(item, index,'calcClick');
      this.$emit('calcClick', item, index)
    },
    
    searchDriverNameFn(name, search) {
     return name?.includes(search.trim().toLowerCase()) ? name?.includes(search.trim().toLowerCase()) : name?.includes(search.trim().toUpperCase())
    },
    timeDiffAll: tools.timeDiffAll,
    formatDateTimeRender(value) {
        let time3 = "";
        if (value) {
            let time2 = value.split(":");
            time3 = time2.length === 2 && time2[0] + "h" + " " + time2[1] + "m";
            return time3;
        }
    },
    input(value, index) {
      this.$emit('calcInput', value, index)
    }
  }
}
</script>

<style scoped lang="scss">
.assign-solo {
  width: 382px;
  overflow-y: scroll;
  height: 332px;
  .split {
    bottom: -4px;
    position: absolute;
    width: 377px;
    height: 1px;
    background: #E7EBF3;
    left: 3.5px;
  }
  .item {
    // height: 105px;
    width: 382px;
    margin: 8px 0;
    padding: 16px 16px 14px 42px;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    &:hover {
      background: #F5F6F8;
    }
    &.selected {
      background-color: rgba(64, 102, 212, 0.08);
      .box {
        border: 5px solid #4066D4;
      }
    }
    .box {
      border: 1px solid #B2B6C0;
      border-radius: 8px;
      box-sizing: border-box;
      position: absolute;
      left: 16px;
      top: 16px;
      width: 16px;
      height: 16px;
    }
    .driver {
      display: flex;
      .left {
        flex: 1;
        display: flex;  
.role {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 0px;
          gap: 8px;

          width: 146px;
          height: 20px;

        .name {
          font-weight: 600;
          font-size: 14px;
          max-width: 230px;
        }
        .text{
        width: 37px;
        height: 16px;

        /* Regular/12 */

        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        /* identical to box height, or 133% */


        /* Neutral Color/Side Bar Icon Color-#A0B4D6 */

        color: #A0B4D6;
        }
}
        .avatar {
          margin-right: 8px;
        }
      }
      .right {
        font-weight: 400;
        font-size: 12px;
        color: #7F8596;
      }
    }
    .desc {
      display: flex;
      .left {
        flex: 1;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #7F8596;
      }
      .right {
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        max-width: 200px;
      }
    }
    .line-bottom {
      margin-bottom: 3px;
    }
    .line1 {
      border-bottom: 1px solid #E7EBF3;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
    .eld-info-container {
        display: flex;
        padding: 8px 16px 5px 0px;
        .eld-item {
            width: 25%;
            margin-left: 24px;
            &:first-child {
                margin-left: 0px;
            }
            p {
              font-family: OpenSans;
              font-weight: 400;
              font-size: 12px;
              color: #7F8596;
              &:last-child {
                  font-weight: 600;
                  color: #000000;
              }
            }
        }
    }
    .no-eld-info-container {
        padding: 8px 16px 0px 0px;
        span {
          font-family: OpenSans;
          font-weight: 400;
          font-size: 12px;
          color: #7F8596;
          margin-left: 8px;
        }
    }
  }

}

</style>
